"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScrollWithMouseDrag_1 = __importDefault(require("@web/common/ScrollWithMouseDrag"));
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
(() => {
    let ScrollDirection;
    (function (ScrollDirection) {
        ScrollDirection["LEFT"] = "left";
        ScrollDirection["RIGHT"] = "right";
    })(ScrollDirection || (ScrollDirection = {}));
    const tableContainer = document.querySelector('.table-container');
    const comparatorTable = document.querySelector('.comparator-table');
    const comparatorTableContainer = document.querySelector('.comparator-table-container');
    const stickyTableHeader = document.querySelector('.sticky-table-header');
    const tableContainerElement = document.querySelector('.table-container');
    const bottomNavigation = document.querySelector('.arrow-navigation');
    if (tableContainer === null || comparatorTable === null || comparatorTableContainer === null || stickyTableHeader === null
        || tableContainerElement === null || bottomNavigation === null) {
        return;
    }
    const bottomNavigationLeft = bottomNavigation.querySelector('.left');
    const bottomNavigationRight = bottomNavigation.querySelector('.right');
    const bottomNavigationTop = bottomNavigation.querySelector('.top');
    const scrollWithMouseDrag = new ScrollWithMouseDrag_1.default(tableContainerElement);
    const removeElements = Array.from(comparatorTable.querySelectorAll('.remove-offer'));
    function calculateStickyHeaderWidth() {
        if (comparatorTableContainer && stickyTableHeader) {
            stickyTableHeader.style.maxWidth = `${String(comparatorTableContainer.offsetWidth)}px`;
        }
    }
    function enableBottomNavigationItem(element) {
        if (element) {
            element.classList.remove('disable');
        }
    }
    function disableBottomNavigationItem(element) {
        if (element) {
            element.classList.add('disable');
        }
    }
    function checkNavigationStatesByScroll() {
        if (stickyTableHeader === null || tableContainer === null) {
            return;
        }
        const scrollLeft = Number(tableContainer.scrollLeft);
        const tableContainerVisibleWidth = Number(Math.round(tableContainer.offsetWidth));
        const tableContainerTotalWidth = Number(tableContainer.scrollWidth);
        const stickyTableInner = stickyTableHeader.querySelector('.inner');
        const isScrolledToLeft = Number(tableContainer.scrollLeft) === 0;
        const isScrolledToRight = tableContainerTotalWidth - scrollLeft <= tableContainerVisibleWidth;
        if (stickyTableInner) {
            stickyTableInner.scrollLeft = scrollLeft;
        }
        if (isScrolledToLeft) {
            disableBottomNavigationItem(bottomNavigationLeft);
        }
        else {
            enableBottomNavigationItem(bottomNavigationLeft);
        }
        if (isScrolledToRight) {
            disableBottomNavigationItem(bottomNavigationRight);
        }
        else {
            enableBottomNavigationItem(bottomNavigationRight);
        }
    }
    function checkNavigationStatesByTableWidth() {
        if (tableContainer === null || comparatorTable === null) {
            return;
        }
        const elementHasScrollbar = tableContainer.offsetWidth < comparatorTable.offsetWidth;
        if (elementHasScrollbar) {
            enableBottomNavigationItem(bottomNavigationRight);
            if (ScreenSize_1.default.isSmallScreen() === false) {
                scrollWithMouseDrag.create();
            }
        }
        else {
            disableBottomNavigationItem(bottomNavigationRight);
            disableBottomNavigationItem(bottomNavigationLeft);
            scrollWithMouseDrag.destroy();
        }
    }
    function scrollByClick(direction) {
        if (tableContainer === null) {
            return;
        }
        const columnWidth = 230;
        tableContainer.scroll({
            left: tableContainer.scrollLeft + (direction === 'left' ? -columnWidth : columnWidth),
            behavior: 'smooth',
        });
    }
    scrollWithMouseDrag.init();
    removeElements.forEach((removeElement) => {
        removeElement.addEventListener('click', (event) => {
            event.preventDefault();
            const offerId = removeElement.dataset.priceOfferId;
            const offerDealType = removeElement.dataset.priceOfferType;
            const offerContractLength = removeElement.dataset.priceOfferContractLength;
            const args = {
                priceOfferId: offerId,
                dealType: offerDealType,
            };
            if (offerContractLength) {
                Object.assign(args, {
                    contractLength: offerContractLength,
                });
            }
            const url = SymfonyRouter_1.default.getRoute('api.car_offer.subscription.price_offer.remove_from_comparison', args);
            const xhr = new XMLHttpRequest();
            xhr.open('DELETE', url, true);
            xhr.onload = () => {
                if (xhr.status === 200) {
                    const moreOffersElement = document.getElementById('comparator-more-offers');
                    const theadRow = comparatorTable.querySelector('thead > tr');
                    const theadCells = Array.from(comparatorTable.querySelectorAll('thead > tr > th'));
                    const currentTheadCell = removeElement.closest('th');
                    const counterElement = comparatorTable.querySelector('.counter');
                    const headerCntElement = document.querySelector('.compare-offers-link .items-count');
                    const index = currentTheadCell ? theadCells.indexOf(currentTheadCell) : null;
                    if (index === null || theadRow === null || counterElement === null || headerCntElement === null) {
                        return;
                    }
                    const counter = String(Number(counterElement.dataset.counter) - 1);
                    const tableCells = Array.from(comparatorTable.querySelectorAll(`td:nth-child(${index}), th:nth-child(${index})`));
                    const stickyTableCell = stickyTableHeader.querySelector(`.inner .column:nth-child(${index})`);
                    if (stickyTableCell) {
                        stickyTableCell.remove();
                    }
                    tableCells.forEach((cell) => {
                        cell.remove();
                    });
                    if (theadCells.length === 4 && moreOffersElement) {
                        moreOffersElement.classList.remove('hidden');
                    }
                    if (theadCells.length === 3) {
                        comparatorTableContainer.remove();
                    }
                    counterElement.dataset.counter = counter;
                    counterElement.innerHTML = counter;
                    headerCntElement.innerHTML = counter;
                    checkNavigationStatesByTableWidth();
                }
            };
            xhr.send();
        });
    });
    checkNavigationStatesByTableWidth();
    calculateStickyHeaderWidth();
    window.addEventListener('scroll', () => {
        const topScroll = window.scrollY;
        const tableTopOffset = comparatorTable.offsetTop;
        const tableBottomEdge = comparatorTableContainer.offsetHeight + comparatorTable.offsetTop - window.outerHeight;
        const theadRow = comparatorTable.querySelector('thead > tr');
        if (topScroll <= tableTopOffset) {
            disableBottomNavigationItem(bottomNavigationTop);
        }
        else {
            enableBottomNavigationItem(bottomNavigationTop);
        }
        if (topScroll >= tableBottomEdge) {
            bottomNavigation.classList.remove('fixed');
        }
        else {
            bottomNavigation.classList.add('fixed');
        }
        if (theadRow === null) {
            return;
        }
        const topOffset = tableTopOffset + theadRow.offsetHeight;
        const bottomOffset = tableTopOffset + comparatorTable.offsetHeight - window.outerHeight;
        if ((topScroll > topOffset) && (topScroll < bottomOffset)) {
            stickyTableHeader.classList.add('show');
        }
        else {
            stickyTableHeader.classList.remove('show');
        }
    });
    window.addEventListener('resize', () => {
        checkNavigationStatesByTableWidth();
        calculateStickyHeaderWidth();
    });
    tableContainer.addEventListener('scroll', () => {
        checkNavigationStatesByScroll();
    });
    Array.from(bottomNavigation.querySelectorAll('.nav')).forEach((nav) => {
        nav.addEventListener('click', (event) => {
            event.preventDefault();
            if (nav.classList.contains('left')) {
                scrollByClick(ScrollDirection.LEFT);
            }
            else if (nav.classList.contains('right')) {
                scrollByClick(ScrollDirection.RIGHT);
            }
            else if (nav.classList.contains('top')) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }
        });
    });
})();
